// const calculate = (item, time) => {
// 	switch (item) {
// 		case "popover": // close within 2 seconds to get bonus score
// 			return time < 2000 ? 5000 : 1000;
// 		default:
// 			return 0;
// 	}
// };

const game = (state = {}, action) => {
	const roundTime = 8;
	switch (action.type) {
		// timer
		case "UPDATE_TIME":
			const time = state.time - 1;
			if (time > 0) {
				return Object.assign({}, state, {
					time: time,
					roundStarted: true
				});
			} else {
				return Object.assign({}, state, {
					time: 0,
					roundOver: true,
					showBlocker: true
				});
			}

		// case "SET_ROUND":
		// 	return Object.assign({}, state, {
		// 		currentRound: action.roundNumber
		// 	});

		// // Ads
		case "ROUND_WIN":
			return Object.assign({}, state, {
				roundOver: true
			});

		case "HIDE_BLOCKER":
			return Object.assign({}, state, {
				showBlocker: false
			});

		// set token for playback
		case "SET_EMBED_TOKEN":
			return Object.assign({}, state, {
				token: action.token
			});

		case "DELETE_PLAYBACK_TOKEN":
			return Object.assign({}, state, {
				token: undefined
			});

		// set token for playback
		case "AUDIO_CHOSEN":
			return Object.assign({}, state, {
				audioSet: true
			});

		// initial player for new game
		case "INITIALIZE_USER":
			return Object.assign({}, state, {
				time: roundTime,
				score: 0,
				darkPatternsKilled: 0,
				roundOver: false,
				isGameOver: false,
				showBlocker: true,
				showPowerUp: false,
				roundStarted: false,
				hazRageClick: false,
				clicks: 0,
				mute: false
			});

		case "INITIALIZE_TIME":
			return Object.assign({}, state, {
				time: roundTime,
				roundOver: false,
				roundStarted: false,
				clicks: 0,
				hazRageClick: false
			});

		case "RAGE_TRIGGER_OFF":
			return Object.assign({}, state, {
				rageTrigger: false
			});

		case "RAGE_CLICK_OFF":
			return Object.assign({}, state, {
				hazRageClick: false
			});

		case "SCORE_INCREASE":
			// const addScore = calculate(action.item, action.time);

			let score = state.score || 0;

			score += action.value || 0;

			// console.log(action, addScore);

			return Object.assign({}, state, { score });

		case "SHOW_POWER_UP":
			return Object.assign({}, state, {
				showPowerUp: true
			});

		case "SHAKE_ON":
			return Object.assign({}, state, {
				shake: true
			});

		case "SHAKE_OFF":
			return Object.assign({}, state, {
				shake: false
			});

		case "SET_MUTE":
			return Object.assign({}, state, {
				mute: action.mute
			});

		case "SET_RANK":
			return Object.assign({}, state, {
				rank: action.rank
			});

		case "IS_MOBILE":
			return Object.assign({}, state, {
				mobile: action.mobile
			});

		default:
			return state;
	}
};

export default game;



// WEBPACK FOOTER //
// ./src/reducers/game.js